import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import { Table } from "../../../components/Table/Table";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const GroupEscalationTime = () => {
  const userData = JSON.parse(localStorage.getItem("user_details"));
  const loginData = JSON.parse(localStorage.getItem("loginData"));

  const [groupEscalations, setGroupEscalations] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");

  const getList = (site_id) => {
    setSelectedSite(site_id);
    get(URL.GROUP_USERS + site_id)
      .then((res) => {
        if (res?.data?.escalations?.length > 0) {
          setGroupEscalations(res?.data?.escalations);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (userData?.knf_type >= 4 && userData?.knf_type <= 4) {
      if (loginData?.sites?.[0]?.id) {
        let site_id_ = loginData?.sites?.[0]?.id;
        setSelectedSite(site_id_);
        getList(site_id_);
      }
      setSiteList(loginData?.sites);
    } else {
      setSelectedSite(userData?.knf_company_site_id);
      getList(userData?.knf_company_site_id);
    }
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      accessor: "sno",
      Cell: ({ value, row }) => {
        return <p>{row.index + 1}</p>;
      },
    },
    {
      Header: "Escalation type",
      accessor: "from_group",
      Cell: ({ value, row }) => {
        return (
          <p>
            {" "}
            {row?.original?.from_group
              ? `Group  ${row?.original?.from_group} `
              : ""}
            {row?.original?.to_group
              ? `→ Group  ${row?.original?.to_group}`
              : ""}
          </p>
        );
      },
    },
    {
      Header: "Severity type",
      accessor: "severity",
      Cell: ({ value, row }) => {
        return <p className="ms-4">{value}</p>;
      },
    },
    {
      Header: "Value ( in minutes)",
      accessor: "escalation_minutes",
      Cell: ({ value, row }) => {
        return <p className="ms-4">{value}</p>;
      },
    },
  ]);

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Escalation Time Settings"} hide={true} />
      {userData?.knf_type >= 4 && userData?.knf_type <= 4 && (
        <div className="col-md-3 mb-3">
          {siteList?.length > 0 && (
            <select
              name="Site"
              value={selectedSite}
              className={`input-pop ps-2 w-100 `}
              onChange={(e) => getList(e.target.value)}
            >
              {siteList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
          )}
        </div>
      )}
      <Table columns={columns} data={groupEscalations} />
    </div>
  );
};

export default GroupEscalationTime;
